import type { SVGProps } from 'react'
const SvgSyArrowRight = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M4.75 10.977a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
			<path d="M13.7 4.951a.75.75 0 0 0-.532.22.75.75 0 0 0 .004 1.061l5.515 5.493-5.515 5.494a.75.75 0 0 0-.004 1.06.75.75 0 0 0 1.06.002l6.051-6.025a.75.75 0 0 0 0-1.063L14.23 5.17a.75.75 0 0 0-.53-.219" />
		</g>
	</svg>
)
export default SvgSyArrowRight
